// Typelizer digest 1858bdae6ade4eaa6a506a6b5937fca1
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../runtime'
import { buildUrl } from '../runtime'

export default {
  /** POST /learners/schools/:school_id/students/:student_id/preference_publications */
  learnersSchoolStudentPreferencePublications: (
    params: { schoolId: string | number; studentId: string | number },
    options?: RouteOptions,
  ): RouteDefinition<'post'> => ({
    url: buildUrl('/learners/schools/:school_id/students/:student_id/preference_publications', params, options),
    method: 'post',
  }),

  /** POST /learners/students/:student_id/preference_publications */
  learnersStudentPreferencePublications: (
    params: { studentId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'post'> => ({
    url: buildUrl('/learners/students/:student_id/preference_publications', params, options),
    method: 'post',
  }),
}
